<template>
  <div>
    <slot name="header"></slot>
    <slot name="hero"></slot>
    <slot name="my-courses"></slot>
    <slot name="other-courses"></slot>
    <slot name="author"></slot>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'PortalMarkup',
  props: {
    bgColor: {},
  },
  data() {
    return {
      // user: { name: 'Prakash Saini' },
    };
  },
};
</script>

